import { inject, Injectable } from '@angular/core';
import { isNil } from '@sama/micro-dash';
import { isUndefined } from 'lodash';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { keys } from '../../../../../cross-team-shared/misc-utils/keys';
import { ShapeService } from '../../../../shared/misc-services/shape.service';
import { RootShapeSelectionService } from './root-shape-selection.service';

/**
 * Sibling of FocusedShapeService to hackily and temporally implement the
 * same functionality but for the root workspace.
 */
@Injectable()
export class RootFocusedShapeService {
  private rootSelectionService = inject(RootShapeSelectionService);
  private shapeService = inject(ShapeService);

  getFocusedShapeIndex(outputName?: string) {
    const selectedShapeIds = outputName
      ? this.rootSelectionService.getNestedSelectionForOutput(outputName)
      : keys(this.rootSelectionService.getNestedSelection());

    if (selectedShapeIds.length !== 1) {
      return undefined;
    }

    return selectedShapeIds[0];
  }

  getFocusedShapeStore() {
    const selectedIndex = this.getFocusedShapeIndex();
    if (isUndefined(selectedIndex)) {
      return undefined;
    }

    return this.getShapeStore(selectedIndex);
  }

  getFocusedShapeStore$() {
    return this.rootSelectionService.getSelection$(false).pipe(
      map(() => this.getFocusedShapeStore()),
      distinctUntilChanged((prev, curr) => {
        if (isNil(prev) && isNil(curr)) {
          return true;
        }
        if (isNil(prev) || isNil(curr)) {
          return false;
        }
        return prev.refersToSameStateAs(curr);
      }),
    );
  }

  private getShapeStore(shapeIndex: number) {
    return this.shapeService.shapeExists(shapeIndex)
      ? this.shapeService.getShapeStore(shapeIndex)
      : undefined;
  }
}
